import { defineNuxtPlugin, useCookie } from '#imports'

import { MarketplaceCode } from '@backmarket/http-api/src/api-models/MarketplaceCode'
import type { PartnerNames } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

const ALLOWED_UTM_SOURCES = new Set([
  'VISIBLE',
  'RAKUTEN',
  'NOBLE',
  'BESTPHONEPLANS',
  'GOOGLE_FI',
  'US_MOBILE',
  'DUOLINGO',
] as const satisfies ReadonlyArray<PartnerNames>)

function isAllowedUtmSource(value: string): value is PartnerNames {
  return ALLOWED_UTM_SOURCES.has(value.toUpperCase() as PartnerNames)
}

const ALLOWED_UTM_CAMPAIGNS = new Set(['purchase', 'browsing'])

export default defineNuxtPlugin(() => {
  const urlParams = new URLSearchParams(window.location.search)
  const utmSourceParam = urlParams.get('utm_source')

  if (utmSourceParam) {
    const { market } = useMarketplace()
    if (
      market.marketplace === MarketplaceCode.NA &&
      isAllowedUtmSource(utmSourceParam)
    ) {
      const utmSource = useCookie('utm_source', {
        // Session cookie - clears when browser closes
        maxAge: undefined,
      })
      utmSource.value = utmSourceParam

      const utmCampaignParam = urlParams.get('utm_campaign')
      if (
        utmCampaignParam &&
        utmSourceParam.toUpperCase() === 'NOBLE' &&
        ALLOWED_UTM_CAMPAIGNS.has(utmCampaignParam)
      ) {
        const utmCampaign = useCookie('utm_campaign', {
          // Session cookie - clears when browser closes
          maxAge: undefined,
          watch: false,
        })
        utmCampaign.value = utmCampaignParam
      }

      const partnerPromotion = useCookie('partner_promotion', {
        maxAge: undefined,
      })
      const promotionParam = urlParams.get('promotion')
      if (promotionParam) {
        partnerPromotion.value = promotionParam
      }
    }
  }
})
